// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'
import abbreviate from 'number-abbreviate'

class Category extends React.Component {
  render () {
    const { category, count, onCategoryClick, selected } = this.props

    const renderClass = () => {
      let klass = 'grid-x '
      if (category.level === 'level_1') {
        klass = klass + 'top '
      }
      if (selected) {
        klass = klass + 'selected '
      }
      return klass
    }

    return (
      <li key={category.id} className={renderClass()} onClick={() => onCategoryClick(category)}>
        <h2 className='auto cell name'>
          {category.level === 'level_1' ? 'All ' : ''} {category.name}
        </h2>
        <div className='shrink cell count'>{abbreviate(count, 1)}</div>
      </li>
    )
  }
}

Category.propTypes = {
  category: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  onCategoryClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired
}

export default Category
